import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import GeoView from 'views/customers/geo'; // Importing GeoView component
import MoneyView from 'views/customers/money'; // Importing MoneyView component
import AgeView from 'views/customers/age'; // Importing AgeView component
import TagsView from 'views/customers/tags'; // Importing TagsView component
import PositionsView from 'views/customers/positions'; // Importing PositionsView component

/**
 * StatisticsView class extends JetView to create a custom view for statistics.
 */
export default class StatisticsView extends JetView {
    /**
     * Configures the layout of the StatisticsView.
     * @returns {Object} The configuration object for the view layout.
     */
    config() {
        return {
            rows: [
                // Main layout structure using rows
                {
                    height: 10, // Spacer row with fixed height
                },
                {
                    type: 'wide', // Main container of the view
                    rows: [
                        // Nested rows for layout
                        {
                            gravity: 2, // Defines the growth factor for this row
                            type: 'wide', // Container for columns
                            cols: [
                                // Columns within the row
                                GeoView, // First column with GeoView component
                                {
                                    type: 'wide', // Second column container
                                    minWidth: 370, // Minimum width for this column
                                    rows: [PositionsView, TagsView], // Nested rows with PositionsView and TagsView
                                },
                            ],
                        },
                        {
                            type: 'wide', // Another row for additional columns
                            cols: [MoneyView, AgeView], // Columns with MoneyView and AgeView components
                        },
                    ],
                },
            ],
        };
    }
}

// FILE DOCUMENTED
